import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
/*ScrollTrigger.config({
    autoRefreshEvents: "visibilitychange,DOMContentLoaded,load" // notice "resize" isn't in the list
});*/
const playVideoThenShowContent = () =>{
    if(document.querySelector('.container-video-background')){
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const allVidBackground = document.querySelectorAll('.container-video-background');
        if(vw > 576){
            if(allVidBackground.length > 0){
                allVidBackground.forEach((bg, index) => {
                    let video = bg.querySelector('.kirinus-cover-video');
                    let contentContainer = bg.querySelector('.kirinus-cover-video-overlay');
                    let content = bg.querySelector('.krinus-cover-video-overlay--content');
                    if(video !== null){
                        let tlPlayVideo = gsap.timeline({
                            scrollTrigger:{
                                scrub: true,
                                //markers: true,
                                trigger: bg,
                                start: 'top bottom',
                                end: 'bottom top',
                            }
                        });
                       // tlPlayVideo.fromTo(video, {opacity: 0}, {opacity: 1, duration: 1.5}, )
                    }
                    let tl = gsap.timeline({
                        scrollTrigger:{
                            scrub: true,
                            //markers: true,
                            trigger: bg,
                            start: 'top-=100px top',
                            end: 'bottom top',
                            toggleActions: 'restart pause reverse reset',
                            animation: tl,
                            pin: bg,
                            snap: {
                                snapTo: "labels", // snap to the closest label in the timeline
                                duration: {min: 0.2, max: 0.5}, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
                                delay: 0.2, // wait 0.2 seconds from the last scroll event before doing the snapping

                            },
                        }
                    })

                  //  tl.fromTo(contentContainer, {opacity: 0}, {opacity: 1, duration: 1}, )
                    tl.addLabel('end');


                })
            }
        }


    }
}
export default playVideoThenShowContent;